import { required } from 'vuelidate/lib/validators'

export default {
  lock: {
    lock_type_id: {
      required
    },
    name: {
      required
    },
    date_start: {
      required
    },
    date_end: {
      required
    },
    time_start: {
      required
    },
    time_end: {
      required
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/agenda/locks/form/resources/validations.js